import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiGrid, FiHome } = FiIcons;

export default function BrandLogo({ size = "md", color = "light" }) {
  const containerClasses = {
    sm: "gap-2",
    md: "gap-3",
    lg: "gap-4"
  };

  const iconClasses = {
    sm: "w-8 h-8 rounded-lg text-lg",
    md: "w-10 h-10 rounded-xl text-xl",
    lg: "w-14 h-14 rounded-2xl text-3xl"
  };

  const textClasses = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-4xl"
  };

  return (
    <div className={`flex items-center ${containerClasses[size]} select-none`}>
      <div className={`relative flex items-center justify-center transform rotate-3 shadow-lg shadow-yellow-300/20 ${iconClasses[size]} ${color === 'light' ? 'bg-yellow-300 text-[#1a365d]' : 'bg-[#1a365d] text-yellow-300'}`}>
        <SafeIcon icon={FiGrid} />
        <div className="absolute -top-1 -right-1 w-1/2 h-1/2 bg-inherit rounded-full flex items-center justify-center scale-75 border-2 border-white">
          <SafeIcon icon={FiHome} className="text-[0.6em]" />
        </div>
      </div>
      <h1 className={`font-black tracking-tighter ${textClasses[size]} ${color === 'light' ? 'text-white' : 'text-[#1a365d]'}`}>
        Parent<span className={color === 'light' ? 'text-yellow-300' : 'text-blue-600'}>Pad</span>
      </h1>
    </div>
  );
}